export default class Gender {}

Gender.Male = 'MALE';
Gender.Female = 'FEMALE';
Gender.Other = 'OTHER';
